import { api } from '../../../services/api/client';
import type { Faq, HelpSettings } from '../../../types';

export async function fetchPublicFaqs(): Promise<Faq[]> {
  const { data } = await api.get<Faq[]>('/public/faqs');
  return data;
}
export async function fetchPublicHelp(): Promise<HelpSettings> {
  const { data } = await api.get<HelpSettings>('/public/help');
  return data;
}
export async function adminListFaqs(): Promise<Faq[]> {
  const { data } = await api.get<Faq[]>('/admin/faqs');
  return data;
}
export interface FaqPayload {
  category: string;
  question: string;
  answer?: string;
  sort_order?: number;
  is_published?: boolean;
}
export async function adminCreateFaq(payload: FaqPayload): Promise<Faq> {
  const { data } = await api.post<Faq>('/admin/faqs', payload);
  return data;
}
export async function adminUpdateFaq(id: string, payload: Partial<FaqPayload>): Promise<Faq> {
  const { data } = await api.put<Faq>(`/admin/faqs/${id}`, payload);
  return data;
}
export async function adminDeleteFaq(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/faqs/${id}`);
  return data;
}
export async function adminGetHelp(): Promise<HelpSettings> {
  const { data } = await api.get<HelpSettings>('/admin/help');
  return data;
}
export async function adminUpdateHelp(payload: Partial<HelpSettings>): Promise<HelpSettings> {
  const { data } = await api.put<HelpSettings>('/admin/help', payload);
  return data;
}

export function waLink(number: string, message = ''): string {
  const digits = (number || '').replace(/\D/g, '');
  const q = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${digits}${q}`;
}
